export class NoteType {
  static feed = "feed";
  static location = "location";
  static training = "training";
  static weight = "weight";
  static other = "other";
  static sign = "sign";
  static attendingVetForm = "attendingVetForm";
  static mdf1A_mdf1B_declaration = "mdf1A_mdf1B_declaration";
  static mdf2_declaration = "mdf2_declaration";
  static mdf3_declaration = "mdf3_declaration";
  static preTravel_vet_form = "preTravel_vet_form"; //HK
  //Pre Race notes tab for RV
  static trainer_veterinary_history_form = 'trainer_vertinary_history_form';
  static trainer_declaration_execution_submission_form = 'trainer_declaration_execution_submission_form';
  static veterinary_inspection_form = 'veterinary_inspection_form';
  static veterinary_declaration_execution_submission_form = 'veterinary_declaration_execution_submission_form';

  //Pre Travel notes tab for RV
  static aus_rv_pre_travel_veterinary_history_disclosure = 'pre_travel_veterinary_history_disclosure';
  static aus_rv_declarations_excecution = 'pre_travel_declarations_excecution';
  static aus_rv_veterinary_inspection = 'pre_travel_veterinary_inspection_form';
  static aus_rv_veterinary_declaration_execution_submission_form = 'pre_travel_veterinary_declaration_execution_submission_form';
  static hongkongHealthCertificate = "hk_health_certificate"
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/core/types/note-type.ts